import React, { useState } from "react";
import { useLocation } from "react-router-dom"; // Aktif sayfa için
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PhoneIcon from "@mui/icons-material/Phone";
import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
    palette: {
        primary: { main: "#3f485d" },
        secondary: { main: "#ffffff" },
        text: { primary: "#1d3c6a", secondary: "#bec1c7" },
    },
    typography: { fontFamily: "Arial, sans-serif" },
});

const Navbar = () => {
    const location = useLocation(); // Mevcut sayfanın yolunu al
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorEl2, setAnchorEl2] = useState(null);
    const [drawerOpen, setDrawerOpen] = useState(false);

    const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
    const handleMenuClose = () => setAnchorEl(null);

    const handleMenuOpen2 = (event) => setAnchorEl2(event.currentTarget);
    const handleMenuClose2 = () => setAnchorEl2(null);

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setDrawerOpen(open);
    };

    const menuItems = [
        { text: "Ana Sayfa", path: "/" },
        { text: "Hakkımızda", path: "/hakkimizda" },
        { text: "Şirket Kuruluş Hizmetleri", path: "/hizmetler/sirket-kurulus-hizmetleri" },
        { text: "Muhasebe ve Mali Müşavirlik", path: "/hizmetler/muhasebe-ve-mali-musavirlik-hizmetleri" },
        { text: "Mali Danışmanlık", path: "/hizmetler/mali-danismanlik-hizmetleri" },
        { text: "Bordrolama ve Personel Hizmetleri", path: "/hizmetler/bordrolama-ve-personel-hizmetleri" },
        { text: "Yönetim ve Denetim Hizmetleri", path: "/hizmetler/yonetim-ve-denetim-hizmetleri" },
        { text: "Yapılandırma, Teşvik ve Hibe Danışmanlığı", path: "/hizmetler/yapilandirma-tesvik-ve-hibe-danismanligi" },
        { text: "E‑Ticaret Satış Muhasebesi", path: "/hizmetler/e-ticaret-satis-muhasebesi" },
        { text: "Mevzuat", path: "/bilgi/mevzuat" },
        { text: "Asgari Ücret", path: "/bilgi/asgari-ucret" },
        { text: "KDV Oranları", path: "/bilgi/kdv-oranlari" },
        { text: "İletişim", path: "/iletisim" },
    ];

    // Buton aktifse farklı stil uygula
    const getButtonStyle = (path) => ({
        textTransform: "none",
        fontSize: "1rem",
        fontWeight: location.pathname === path ? "bold" : "normal",
        color: location.pathname === path ? "#0f647c" : "#1d3c6a",
        borderBottom: location.pathname === path ? "2px solid #0f647c" : "none",
    });

    return (
        <ThemeProvider theme={theme}>
            {/* Üst Bilgi Çubuğu */}
            <AppBar position="static" color="primary" elevation={0} sx={{ padding: "4px 0", display: { xs: 'none', md: 'flex'} }}>
                <Toolbar sx={{ display: "flex", justifyContent: "space-between", maxWidth: "1200px", margin: "auto", width: "100%", minHeight: "30px" }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2, color: "text.secondary" }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <EmailIcon fontSize="small" />
                            <Typography variant="caption" color="white">gulden.cetinkayakopan@ismmmo.org.tr</Typography>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <AccessTimeIcon fontSize="small" />
                            <Typography variant="caption" color="white">Çalışma Saatleri - Pzt - Cuma: 08:30 - 18:00</Typography>
                        </Box>
                    </Box>

                    {/* Telefon Bilgisi */}
                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <PhoneIcon sx={{ color: "#ffffff", }} fontSize="small" />
                            <Typography variant="h8" sx={{ fontWeight: "bold", variant: "caption" }}>
                                0552 167 36 34
                            </Typography>
                        </Box>
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <IconButton color="inherit" href="#" size="small"><FacebookIcon fontSize="small" /></IconButton>
                        <IconButton color="inherit" href="#" size="small"><TwitterIcon fontSize="small" /></IconButton>
                        <IconButton color="inherit" href="#" size="small"><LinkedInIcon fontSize="small" /></IconButton>
                    </Box>
                </Toolbar>
            </AppBar>

            <AppBar position="static" color="secondary" elevation={0} sx={{ padding: "10px 0", borderBottom: "1px solid #ddd" }}>
                <Toolbar sx={{ display: "flex", justifyContent: "space-between", maxWidth: "1200px", margin: "auto", width: "100%", minHeight: "60px" }}>

                    {/* Logo */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                        <a href="/" style={{ display: "flex", alignItems: "center" }}>
                            <Box component="img" src="/banner2.png" alt="Logo" sx={{ height: 50 }} />
                        </a>
                    </Box>

                    {/* Menü Linkleri */}
                    <Box sx={{ display: { xs: 'none', md: 'flex'}, gap: 3 }}>
                        <Button color="inherit" href="/" sx={getButtonStyle("/")}>
                            Ana Sayfa
                        </Button>
                        <Button color="inherit" href="/hakkimizda" sx={getButtonStyle("/hakkimizda")}>
                            Hakkımızda
                        </Button>

                        {/* Hizmetler Açılır Menü */}
                        <Box>
                            <Button color="inherit" onClick={handleMenuOpen} sx={getButtonStyle("/hizmetler")}>
                                Hizmetlerimiz
                            </Button>
                            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose} sx={{ mt: 1 }}>
                                <MenuItem onClick={handleMenuClose} component="a" href="/hizmetler/sirket-kurulus-hizmetleri" sx={getButtonStyle("/hizmetler/sirket-kurulus-hizmetleri")}>
                                    Şirket Kuruluş Hizmetleri
                                </MenuItem>
                                <MenuItem onClick={handleMenuClose} component="a" href="/hizmetler/muhasebe-ve-mali-musavirlik-hizmetleri" sx={getButtonStyle("/hizmetler/muhasebe-ve-mali-musavirlik-hizmetleri")}>
                                    Muhasebe ve Mali Müşavirlik
                                </MenuItem>
                                <MenuItem onClick={handleMenuClose} component="a" href="/hizmetler/mali-danismanlik-hizmetleri" sx={getButtonStyle("/hizmetler/mali-danismanlik-hizmetleri")}>
                                    Mali Danışmanlık
                                </MenuItem>
                                <MenuItem onClick={handleMenuClose} component="a" href="/hizmetler/bordrolama-ve-personel-hizmetleri" sx={getButtonStyle("/hizmetler/bordrolama-ve-personel-hizmetleri")}>
                                    Bordrolama ve Personel Hizmetleri
                                </MenuItem>
                                <MenuItem onClick={handleMenuClose} component="a" href="/hizmetler/yonetim-ve-denetim-hizmetleri" sx={getButtonStyle("/hizmetler/yonetim-ve-denetim-hizmetleri")}>
                                    Yönetim ve Denetim Hizmetleri
                                </MenuItem>
                                <MenuItem onClick={handleMenuClose} component="a" href="/hizmetler/yapilandirma-tesvik-ve-hibe-danismanligi" sx={getButtonStyle("/hizmetler/yapilandirma-tesvik-ve-hibe-danismanligi")}>
                                    Yapılandırma, Teşvik ve Hibe Danışmanlığı
                                </MenuItem>
                                <MenuItem onClick={handleMenuClose} component="a" href="/hizmetler/e-ticaret-satis-muhasebesi" sx={getButtonStyle("/hizmetler/e-ticaret-satis-muhasebesi")}>
                                    E‑Ticaret Satış Muhasebesi
                                </MenuItem>
                            </Menu>
                        </Box>

                        <Box>
                            <Button color="inherit" onClick={handleMenuOpen2} sx={getButtonStyle("/bilgi")}>
                                Bilgi
                            </Button>
                            <Menu anchorEl={anchorEl2} open={Boolean(anchorEl2)} onClose={handleMenuClose2} sx={{ mt: 1 }}>
                                <MenuItem onClick={handleMenuClose2} component="a" href="/bilgi/mevzuat" sx={getButtonStyle("/bilgi/mevzuat")}>
                                    Mevzuat
                                </MenuItem>
                                <MenuItem onClick={handleMenuClose2} component="a" href="/bilgi/asgari-ucret" sx={getButtonStyle("/bilgi/asgari-ucret")}>
                                    Asgari Ücret
                                </MenuItem>
                                <MenuItem onClick={handleMenuClose2} component="a" href="/bilgi/kdv-oranlari" sx={getButtonStyle("/bilgi/kdv-oranlari")}>
                                    KDV Oranları
                                </MenuItem>
                            </Menu>
                        </Box>

                        <Button color="inherit" href="/iletisim" sx={getButtonStyle("/iletisim")}>
                            İletişim
                        </Button>
                    </Box>

                    <IconButton
                        color="inherit"
                        edge="start"
                        onClick={toggleDrawer(true)}
                        sx={{ display: { xs: 'flex', md: 'none' }, padding: "0 20px" }}
                    >
                        <MenuIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>

            <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
                <Box
                    sx={{ width: 250 }}
                    role="presentation"
                    onClick={toggleDrawer(false)}
                    onKeyDown={toggleDrawer(false)}
                >
                    <List className="navbar-menu-mobile">
                        {menuItems.map((item) => (
                            <ListItem button key={item.text} component="a" href={item.path}>
                                <ListItemText primary={item.text} />
                            </ListItem>
                        ))}
                    </List>
                </Box>
            </Drawer>
        </ThemeProvider>
    );
};

export default Navbar;
